import { gql } from '@apollo/client';

export const DELETE_FIELD_SESSION_MUTATION = gql`
  mutation DeleteFieldSessionMutation($id: ID!) {
    deleteFieldSession(id: $id)
  }
`;
